/* custom-cl-hero — rotating underlined H1 word (real-Replo dynamic-text pattern).
   Reads comma-separated words from [data-cl-rotate]; 180ms fade-out → swap → width eases to
   the new word + fade-in; interval 2600ms; prefers-reduced-motion = static first word. */
(function () {
  var el = document.querySelector('[data-cl-rotate]');
  if (!el) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var words = (el.getAttribute('data-cl-rotate') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
  if (words.length < 2) return;
  var i = words.indexOf(el.textContent.trim());
  if (i < 0) i = 0;
  el.style.transition = 'opacity .18s ease, width .25s ease';
  var timer = setInterval(function () {
    // Backgrounded tab: the swap costs two forced reflows and nobody can see the result.
    // (Same gate the LP advertorial hero autoplay uses.)
    if (document.hidden) return;
    i = (i + 1) % words.length;
    var w0 = el.getBoundingClientRect().width;
    el.style.opacity = '0';
    setTimeout(function () {
      el.textContent = words[i];
      el.style.width = 'auto';
      var w1 = el.getBoundingClientRect().width;
      el.style.width = w0 + 'px';
      void el.offsetWidth;
      el.style.width = w1 + 'px';
      el.style.opacity = '1';
      setTimeout(function () { el.style.width = 'auto'; }, 280);
    }, 190);
  }, 2600);

  // Editor teardown: `el` is resolved once, so without this the interval keeps mutating a
  // detached node forever after a hero re-render. Never fires on the storefront.
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.contains && e.target.contains(el)) clearInterval(timer);
  });
})();
